import * as React from 'react';

export class Loader extends React.Component {
	render(): JSX.Element {
		return <div id='loader'>loading</div>;
	}
}